import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function ReportFilters({ filters, setFilter, companies, clients, carriers, users, fields }) {
  return (
    <div className="mb-4 flex flex-wrap gap-2" data-testid="report-filters">
      {fields.includes("company") && (
        <Select value={filters.company_id} onValueChange={(v) => setFilter("company_id", v)}>
          <SelectTrigger className="w-40" data-testid="report-filter-company"><SelectValue placeholder="Compañía" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas las compañías</SelectItem>
            {companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.nombre}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      {fields.includes("client") && (
        <Select value={filters.client_id} onValueChange={(v) => setFilter("client_id", v)}>
          <SelectTrigger className="w-48" data-testid="report-filter-client"><SelectValue placeholder="Cliente" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los clientes</SelectItem>
            {clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.razon_social}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      {fields.includes("carrier") && (
        <Select value={filters.carrier_id} onValueChange={(v) => setFilter("carrier_id", v)}>
          <SelectTrigger className="w-48" data-testid="report-filter-carrier"><SelectValue placeholder="Carrier" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los carriers</SelectItem>
            {carriers.map((c) => <SelectItem key={c.id} value={c.id}>{c.razon_social}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      {fields.includes("tipo_viaje") && (
        <Select value={filters.tipo_viaje} onValueChange={(v) => setFilter("tipo_viaje", v)}>
          <SelectTrigger className="w-44" data-testid="report-filter-tipo-viaje"><SelectValue placeholder="Tipo de viaje" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los tipos</SelectItem>
            <SelectItem value="nacional_mx">Solo nacional MX</SelectItem>
            <SelectItem value="nacional_us">Solo nacional US</SelectItem>
            <SelectItem value="transfronterizo">Solo transfronterizo</SelectItem>
          </SelectContent>
        </Select>
      )}
      {fields.includes("dates") && (
        <>
          <Input type="date" value={filters.fecha_desde} onChange={(e) => setFilter("fecha_desde", e.target.value)}
                className="w-36" data-testid="report-filter-fecha-desde" title="Desde" />
          <Input type="date" value={filters.fecha_hasta} onChange={(e) => setFilter("fecha_hasta", e.target.value)}
                className="w-36" data-testid="report-filter-fecha-hasta" title="Hasta" />
        </>
      )}
      {fields.includes("estado_cobro") && (
        <Select value={filters.estado_cobro} onValueChange={(v) => setFilter("estado_cobro", v)}>
          <SelectTrigger className="w-40" data-testid="report-filter-estado-cobro"><SelectValue placeholder="Estado cobro" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los estados</SelectItem>
            <SelectItem value="pendiente">Pendiente</SelectItem>
            <SelectItem value="cobrado">Cobrado</SelectItem>
          </SelectContent>
        </Select>
      )}
      {fields.includes("bucket") && (
        <Select value={filters.bucket} onValueChange={(v) => setFilter("bucket", v)}>
          <SelectTrigger className="w-44" data-testid="report-filter-bucket"><SelectValue placeholder="Antigüedad" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los tramos</SelectItem>
            <SelectItem value="por_vencer">Por vencer</SelectItem>
            <SelectItem value="1-30">1-30 días</SelectItem>
            <SelectItem value="31-60">31-60 días</SelectItem>
            <SelectItem value="61-90">61-90 días</SelectItem>
            <SelectItem value="90+">Más de 90 días</SelectItem>
          </SelectContent>
        </Select>
      )}
      {fields.includes("tipo_fecha") && (
        <Select value={filters.tipo_fecha} onValueChange={(v) => setFilter("tipo_fecha", v)}>
          <SelectTrigger className="w-56" data-testid="report-filter-tipo-fecha"><SelectValue placeholder="Tipo de fecha" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Confirmada y estimada</SelectItem>
            <SelectItem value="confirmada">Solo confirmada (fecha real)</SelectItem>
            <SelectItem value="estimada">Solo estimada (desde despacho)</SelectItem>
          </SelectContent>
        </Select>
      )}
      {fields.includes("user") && (
        <Select value={filters.user_id} onValueChange={(v) => setFilter("user_id", v)}>
          <SelectTrigger className="w-48" data-testid="report-filter-user"><SelectValue placeholder="Usuario" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los usuarios</SelectItem>
            {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.nombre_completo}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
